export default "__VITE_ASSET__BKUDT7lZ__"